import {ItemType} from "../../Data/ItemModel";

export enum MusicType {
    Glockenspiel = ItemType.Glockenspiel,
    Nyatiti = ItemType.Nyatiti,
    Didgeridoo = ItemType.Didgeridoo,
    Bagpipes = ItemType.Bagpipes,
}

export interface MusicModel {
    readonly musicType: MusicType;
}